// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-text[data-v-77bc1a96]{border:thin solid rgba(0,0,0,.12);border-top:none;height:80px}[data-v-77bc1a96] .v-skeleton-loader__image{height:250px!important}[data-v-77bc1a96] .v-skeleton-loader__card-heading{border-radius:0 0 4px 4px!important}[data-v-77bc1a96] .v-skeleton-loader__card-heading{border:thin solid rgba(0,0,0,.12);border-top:none;height:80px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
